import React, { SetStateAction, useState } from 'react';
import CustomButton from '../CustomButton';
import DragFile from '../DragFile';
import { toast } from 'react-toastify';
import { formAxios } from 'components/axios';
import { useGetUser } from 'atom/user';
import { ICodeInfo } from 'types/user';
import { sendTeamRoom } from 'components/nateon';
import { getKoreaDateTime } from 'components/function';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    companyId: number
    getUser: () => void
}

const ChangeCompanyCode = ({ isOpen, setIsOpen, companyId, getUser }: IConfrimDialog) => {
    const user = useGetUser();
    const [once, setOnce] = useState<boolean>(false);

    const [codeInfo, setCodeInfo] = useState<ICodeInfo>({
        reason: '',
        file: null
    });

    const saveCompanyCode = async () => {
        if (!codeInfo.reason) {
            return toast.error('변경사유를 입력해주세요.')
        }
        if (!codeInfo.file) {
            return toast.error('사업자등록증을 업로드해주세요.')
        }

        setOnce(true)
        const formData = new FormData();
        formData.append('reason', codeInfo.reason)
        formData.append('file', codeInfo.file)
        formAxios.post(`company/${companyId}/file`, formData).then(async (res) => {
            if (res.data.code === 200) {
                getUser();
                setIsOpen(false)
                sendTeamRoom('companyFile', `📦 Pulse On Ship 사용자 사업자 등록증 변경 💼\n
신청일시: ${getKoreaDateTime()}
유저: ${user.username}
회사이름: ${user.companyInfo.companyNameKr}
변경사유: ${codeInfo.reason}`)
                setCodeInfo({} as ICodeInfo)
            }
            setOnce(false)
        })
    }

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                <div className="bg-white shadow-lg p-10 mobile:p-6 rounded-lg w-[660px] mobile:w-9/10 mobile:h-9/10">
                    <div className='flex flex-col gap-8'>
                        <div className='flex flex-col gap-2'>
                            <p className="font-semibold mobile:text-lg text-2xl">사업자 등록증 변경</p>
                            <p className='font-semibold text-red mobile:text-sm'>변경 시 로그인이 불가하며 영업일 기준 2~3일 검토 기간이 필요합니다.
                                <br /> 반려 시 별도 연락을 드립니다</p>
                        </div>
                        <div className='flex flex-col gap-3 text-lg text-left'>
                            <textarea
                                className={`w-full h-full rounded-lg p-6 text-sm bg-[#F8F8FA] resize-none`}
                                rows={6}
                                value={codeInfo.reason}
                                placeholder='사업자 등록증 변경 사유를 입력해 주세요.'
                                onChange={(e) => {
                                    setCodeInfo({
                                        ...codeInfo,
                                        reason: e.target.value
                                    })
                                }}
                            >
                            </textarea>

                            <div>
                                <DragFile
                                    description='선택 또는 드래그하여<br />사업자 등록증 파일을 등록해 주세요'
                                    onChangeFile={(file) => {
                                        setCodeInfo({
                                            ...codeInfo,
                                            file: file
                                        })
                                    }}
                                />
                                <p className='text-[#A8A9BF] text-xs'>*파일은 PDF형식의 15MB로 제한됩니다.</p>
                            </div>
                        </div>

                        <div className="flex justify-end gap-4">
                            <CustomButton
                                title={'취소'}
                                disabled={once}
                                onClick={() => {
                                    setCodeInfo({} as ICodeInfo)
                                    setIsOpen(p => !p)
                                }}
                                className='hover:!bg-white !border-[#9D9EB7] w-[200px] mobile:w-full !h-15 !text-[#9D9EB7]'
                            />
                            <CustomButton title={'완료'} onClick={saveCompanyCode} className={'w-[200px] !h-15 bg-primary mobile:w-full'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeCompanyCode;